import { Veneer } from "./veneer";
import { Onlay } from "./onlay";
import { Crown } from "./crown";
import { Bridge } from "./bridge";
import { AdhesiveBridge } from "./adhesive-bridge";
import { Denture } from "./denture";
import { RemoveBridgeDenture } from "./remove-bridge-denture";
import { ArticulatedModels } from "./articulated-models";
import { ProvisionalCrown } from "./provisional-crown";
import { ProvisionalBridge } from "./provisional-bridge";

export const treatments = [
  Veneer,
  Onlay,
  Crown,
  Bridge,
  AdhesiveBridge,
  Denture,
  RemoveBridgeDenture,
  ArticulatedModels,
  ProvisionalCrown,
  ProvisionalBridge,
];



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/prostho/index.ts